(function (window) {
	"use strict";
	function defineContentTypeHelper() {
		var contentTypeHelper = {};
		var extensionsAndContentType = [
			{
				extension: "jpg",
				contentType: "image/jpeg"
			},
			{
				extension: "jpeg",
				contentType: "image/jpeg"
			},
			{
				extension: "png",
				contentType: "image/png"
			},
			{
				extension: "pdf",
				contentType: "application/pdf"
			},
			{
				extension: "docx",
				contentType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
			},
			{
				extension: "doc",
				contentType: "application/msword"
			},
			{
				extension: "xls",
				contentType: "application/vnd.ms-excel"
			},
			{
				extension: "xlsx",
				contentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
			},
			{
				extension: "csv",
				contentType: "text/csv"
			}
		];
		contentTypeHelper.getContentTypeForFile = function(fileName){
			var indexOfExtension = fileName.lastIndexOf(".");
			if(indexOfExtension >= 0){
				for(var i = 0; i < extensionsAndContentType.length; i++){
					var fileExtension = fileName.substr(indexOfExtension + 1).toLowerCase();
					if(fileExtension === extensionsAndContentType[i].extension){
						return extensionsAndContentType[i].contentType;
					}
				}
			}
			//no content type found return null
			return null;
		};
		return contentTypeHelper;
	}
	//define globally if it doesn't already exist
	if (typeof (contentTypeHelper) === "undefined") {
		window.contentTypeHelper = defineContentTypeHelper();
	} else {
		console.log("contentTypeHelper already defined.");
	}
})(window);